import React from "react";

import { buildRetailers, fireGTMEvent } from "helpers/Helper";

import styles from "./RetailerImageButton.module.css";

const RetailerImageButton = (props) => {
  // I use two name properties to preserve the KM tracking format.
  // The GA format is the same as the display names. - JZ
  let retailers = buildRetailers(props);
  let target = "_blank",
    isbn = props.primary_isbn,
    buttons = [];

  retailers.forEach((retailer) => {
    if (retailer.url) {
      let eventLabel = `${props.title} | ${
          props.primary_isbn || props.isbns
        } | ${props.publisher}`,
        eventAction = "Retail Click";
      buttons.push(
        <>
          {props?.urlType === "External Link" ? (
            <a
              href={retailer.url}
              rel="noopener nofollow sponsored"
              className={[styles["anch"], styles["retailer-image-btn"]].join(" ")}
              data-vars-outbound-url={retailer?.url}
              data-vars-outbound-text={retailer?.display}
              target={target}
              onClick={() =>
                fireGTMEvent(
                  "Ebook",
                  props.title,
                  props.primary_isbn,
                  props.isbns,
                  props.publisher,
                  props.isMarketingServices,
                  retailer.kmName,
                  retailer.display
                )
              }
              style={{
                "--retailer-img-width": retailer.customretailername ? "initial" : "150px",
              }}
            >
              <span
                style={{
                  backgroundImage: `url(${retailer.customretailername ? "none" : retailer.backgroundImage})`,
                  width: retailer.customretailername ? "initial" : "150px",
                }}
                className={styles["retailer-img"]}
                role="img"
                aria-label={retailer.alt_text}
                title={retailer.alt_text}
              >
                {retailer.customretailername ? retailer.customretailername : ""}
              </span>
            </a>
          ) : (
            <a
              href={retailer.url}
              rel="noopener nofollow sponsored"
              className={[styles["anch"], styles["retailer-image-btn"]].join(" ")}
              data-vars-event-label={eventLabel}
              data-vars-event-action={eventAction}
              data-vars-outbound-url={retailer.url}
              data-vars-outbound-text={retailer.display}
              target={target}
              onClick={() =>
                fireGTMEvent(
                  "Ebook",
                  props.title,
                  props.primary_isbn,
                  props.isbns,
                  props.publisher,
                  props.isMarketingServices,
                  retailer.kmName,
                  retailer.display
                )
              }
              style={{
                "--retailer-img-width": retailer.customretailername ? "initial" : "150px",
              }}
            >
              <span
                style={{
                  backgroundImage: `url(${retailer.backgroundImage})`,
                  width: retailer.customretailername ? "initial" : "150px",
                }}
                className={styles["retailer-img"]}
                role="img"
                aria-label={retailer.alt_text}
                title={retailer.alt_text}
              >
                {retailer.customretailername ? retailer.customretailername : ""}
              </span>
            </a>
          )}
        </>
      );
    }
  });

  let numOfRetailers = buttons.length;
  if (numOfRetailers > 0) {
    return (
      <div 
        className={[styles["aff_links_container"], "aff_links_container"].join(" ")}
        style={{
          "--aff__links-display": numOfRetailers > 2 ? "flex" : "block",
          "--aff__link-width": numOfRetailers > 2 ? "48%" : "100%",
        }}
      >
        <div className={[styles["availble-at"], "availble-at"].join(" ")}>Available at:</div>
        <div className={[styles["aff__links"], "aff__links"].join(" ")}>
          {buttons.map((button, key) => {
            return (
              <div className={[styles["aff__link"], "aff__link"].join(" ")} key={key}>
                {button}
              </div>
            );
          })}
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default RetailerImageButton;
